import { render } from "./ComparativeNPSBreakdown.vue?vue&type=template&id=c0ded008&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ComparativeNPSBreakdown.vue?vue&type=script&lang=js"
export * from "./ComparativeNPSBreakdown.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__